export default __webpack_public_path__ + "static/media/CU_eggs.7a40aeca.jpg";